import { configureStore } from '@reduxjs/toolkit'
import resultsProfiler from './results-profiler'

const store = configureStore({
  reducer: {
    resultsProfiler
  }
})

export default store